import { ReactNode } from "react";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { getActions } from "./helpers/getActions";
import { ListAction } from "./ListAction";
import { useDataListRow } from "./useDataListRow";
import { BaseProps } from "../../BaseProps";

/**
 * The `Actions` component properties.
 */
export interface DataListActionsProps extends BaseProps {

  /**
   * The actions to be displayed in the section.
   */
  readonly children: ReactNode;
}

/** Section which displays a series of actions. */
export function Actions<ListItem extends object>({ children }: DataListActionsProps) {
  const { row, id } = useDataListRow();
  if (!row) return null;

  const actions = getActions(children).filter(
    (action) => action.visible?.(id) ?? true,
  );

  return (
    <Shelf role="group">
      {actions.map((action, idx) =>
        <Actions.Action {...action} key={idx} />,
      )}
      <Shelf.Spacer />
    </Shelf>
  );
}

/** Represents a single action which can be placed within the `Actions` section component. */
Actions.Action = ListAction;
